import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { User } from '../../user/User'

/**
 * Args for creating/associating a customer from an inbound email's authenticated sender.
 *
 * The email address is the trusted identity (authenticated at the Mailgun boundary); the display-name is
 * untrusted, so a newly created customer is flagged unverified. company/phone are optional — a raw inbound
 * email rarely carries them cheaply.
 */
@InputType()
export class CreateCustomerFromEmailArgs extends ActionArgs {
  @Field(() => String)
  email: string

  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => String, { nullable: true })
  companyName?: string

  @Field(() => String, { nullable: true })
  phone?: string
}

/**
 * Interface for the CreateCustomerFromEmail action.
 * Returns the existing user when the email already maps to one, otherwise the newly created unverified customer.
 */
export interface ICreateCustomerFromEmail extends IAction<User, CreateCustomerFromEmailArgs> {}
